import { render, staticRenderFns } from "./Organizers.vue?vue&type=template&id=39216132"
import script from "./Organizers.vue?vue&type=script&lang=js"
export * from "./Organizers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports